import { render, staticRenderFns } from "./UnansweredForms.vue?vue&type=template&id=18db8dc0&"
import script from "./UnansweredForms.vue?vue&type=script&lang=js&"
export * from "./UnansweredForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports